<template>
    <div class="content digital">
        <p>在数字化转型的浪潮下，由西安锦威电子科技有限公司倾力打造的园区及企业数字化管理平台应运而生。作为专为现代产业园区与企业量身定制的智能化管理平台，我们以"数据驱动决策"为核心理念，深度融合前沿技术，为企业提供从基础管理到智能决策的全栈式数字化解决方案，助力园区与企业实现运营效率与管理质量的双重跃升。
        </p>

        <p class="subtitle">价值与优势</p>
        <p><img src="../../../../../assets/img/product/digital/digital_jiazhi.png"></img></p>
        <p style="margin-top:1.5em;">
            园区及企业数字化管理，不止于系统，更是企业数字化转型的战略引擎。我们深刻理解企业在数字化进程中面临的共性痛点：系统分散、数据孤岛、运维低效、决策滞后、安全风险高等问题，基于十余年行业深耕与技术积累，以“数据驱动、安全可靠、灵活适配”为核心设计理念，为客户带来可量化、可持续的业务价值，助力企业从"被动应对"迈向"主动引领"的数字化新境界。
        </p>

        <p class="subtitle">核心功能模块</p>

        <div style="height: 6em;"></div>
        <el-row>
            <el-col :span="10" class="left-content">
                <h3>智能3D可视化管理</h3>
                <ul>
                    <li>
                        <li-item content="构建高精度园区数字孪生体，实现空间、设施、设备的三维立体呈现"></li-item>
                    </li>
                    <li>
                        <li-item content="支持多层级、多视角的园区空间规划与动态模拟，提升园区规划科学性"></li-item>
                    </li>
                    <li>
                        <li-item content="为园区参观客户提供沉浸式展示体验，提升园区形象与吸引力"></li-item>
                    </li>
                </ul>
            </el-col>
            <el-col :span="14" class="right-content"><div class="img-container" style="width:85%;"><img src="../../../../../assets/img/product/digital/digital_3d.png"></img></div></el-col>
        </el-row>

        <div style="height: 10em;"></div>
        <el-row>            
            <el-col :span="14" class="left-content"><div class="img-container" style="width:90%;"><img src="../../../../../assets/img/product/digital/digital_jicheng.png"></img></div></el-col>
            <el-col :span="10" class="right-content">
                <h3>多系统一体化集成</h3>
                <ul>
                    <li>
                        <li-item content="打破信息孤岛，无缝对接MES、ERP等核心业务系统"></li-item>
                    </li>
                    <li>
                        <li-item content="提供标准化API接口与数据治理服务，支持企业按需定制集成方案"></li-item>
                    </li>
                    <li>
                        <li-item content="降低系统维护成本，提升数据流转效率与应用价值"></li-item>
                    </li>
                </ul>
            </el-col>
        </el-row>

        <div style="height: 10em;"></div>
         <el-row>
            <el-col :span="10" class="left-content">
                <h3>全域实时运行监测</h3>
                <ul>
                    <li>
                        <li-item content="全方位监控园区基础设施、生产环境、能源消耗等关键指标"></li-item>
                    </li>
                    <li>
                         <li-item content="实时采集、分析设备运行数据与环境参数，构建动态监测看板"></li-item>
                    </li>
                    <li>
                        <li-item content="异常自动预警与智能诊断功能，实现问题早发现、早处理"></li-item>
                    </li>
                </ul>
            </el-col>
            <el-col :span="14" class="right-content"><div class="img-container" style="width:85%;"><img src="../../../../../assets/img/product/digital/digital_alarm.png"></img></div></el-col>
        </el-row>

        <div style="height: 10em;"></div>
        <el-row>            
            <el-col :span="14" class="left-content"><div class="img-container" style="width:90%;"><img src="../../../../../assets/img/product/digital/digital_yunwei.png"></img></div></el-col>
            <el-col :span="10" class="right-content">
                <h3>智能运维协同管理</h3>
                <ul>
                    <li>
                        <li-item content="构建跨部门、跨层级的协同工作流程，实现工单闭环管理"></li-item>
                    </li>
                    <li>
                        <li-item content="提供Web、3D、App多终端协同处理与进度跟踪，提升响应速度"></li-item>
                    </li>
                    <li>
                        <li-item content="建立运维知识库，促进经验沉淀与复用"></li-item>
                    </li>
                </ul>
            </el-col>
        </el-row>

        <div style="height: 10em;"></div>
         <el-row>
            <el-col :span="10" class="left-content">
                <h3>透明化资产管理</h3>
                <ul>
                    <li>
                        <li-item content="全生命周期追踪各类资产（设备、设施、IT资产、固定资产等），实现“一物一码”精细化管理"></li-item>
                    </li>
                    <li>
                         <li-item content="支持资产状态、位置、责任人、维保记录等信息的实时可视化，杜绝资产流失与重复采购板"></li-item>
                    </li>
                    <li>
                        <li-item content="结合3D地图精准定位资产物理位置，大幅提升盘点与调度效率"></li-item>
                    </li>
                </ul>
            </el-col>
            <el-col :span="14" class="right-content"><div class="img-container" style="width:88%;margin-top: 10px;"><img src="../../../../../assets/img/product/digital/digital_zichan.png"></img></div></el-col>
        </el-row>

        <div style="height: 10em;"></div>
        <el-row>            
            <el-col :span="14" class="left-content"><div class="img-container" style="width:90%;"><img src="../../../../../assets/img/product/digital/digital_data.png"></img></div></el-col>
            <el-col :span="10" class="right-content">
                <h3>深度数据分析与决策支持</h3>
                <ul>
                    <li>
                        <li-item content="提供多维度数据仪表盘与可视化分析，直观展示运营状况"></li-item>
                    </li>
                    <li>
                        <li-item content="基于AI算法的智能分析，生成定制化运营报告"></li-item>
                    </li>
                    <li>
                        <li-item content="从经验决策迈向数据决策，提升管理精细化水平"></li-item>
                    </li>
                </ul>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import liItem from './liItem.vue';
export default{
    components:{
        liItem
    }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/product.less';
</style>